import type React from "react";
import {Alert, Skeleton} from "@mui/material";
import {Tag} from "~/components/tag/Tag.tsx";
import type {CheckState} from "../contractExplorerTypes.ts";
import {CHECK_STATE_LABEL, KIND_LABEL} from "../contractExplorerTypes.ts";
import {useContractChecksQuery} from "../useContractOpportunitiesQuery.ts";
import {Section} from "./Section.tsx";

const STATE_COLOR: Record<CheckState, 'success' | 'warning' | 'error'> = {ran: 'success', not_met: 'warning', failed: 'error'};

/** What each specialist made of the bundle: checked, not applicable with what was lacking, or failed. */
export const ChecksSection: React.FC<{bagId: number; contractId: number}> = ({bagId, contractId}) => {
    const {data, isPending, error} = useContractChecksQuery(bagId, contractId);
    let body: React.ReactNode;
    if (error) body = <Alert severity="error">The checks could not be loaded: {error.message}</Alert>;
    else if (isPending || !data) body = <Skeleton variant="rounded" height={120}/>;
    else body = (
        <table className="ci-checks">
            <tbody>
                {data.map(c => (
                    <tr key={c.kind}>
                        <td>{KIND_LABEL[c.kind]}</td>
                        <td><Tag label={CHECK_STATE_LABEL[c.state]} color={STATE_COLOR[c.state]} variant="outlined"/></td>
                        <td className="ci-reason">
                            {c.findings > 0 ? `${c.findings} found` : c.missing.join('; ')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
    return (
        <Section title="Agent Specialist"
                 sub="A specialist that could not check the contract says what the contract or the data lacks.">
            {body}
        </Section>
    );
};
